module.exports = __webpack_public_path__ + "02_hige_white.f94f6ca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/02_hige_white.png
// module id = MqMq
// module chunks = 0